import ApproveAndSendReportModal from './ApproveAndSendReportModal.vue';

export default ApproveAndSendReportModal;
